import React from "react";
import { AlertTriangle } from "lucide-react";
import { portalDs } from "src/components/portal-design-system/portal-ds-classes";
import { cn } from "src/lib/utils";
import type { ActivationCommissionWarning } from "../types/commissions.types";

interface ActivationCommissionWarningsBannerProps {
  warnings: ActivationCommissionWarning[];
}

const ActivationCommissionWarningsBanner: React.FC<
  ActivationCommissionWarningsBannerProps
> = ({ warnings }) => {
  if (warnings.length === 0) {
    return null;
  }

  return (
    <div className="space-y-2">
      {warnings.map((warning) => (
        <div
          key={`${warning.code}-${warning.message}`}
          className={cn(
            "flex items-start gap-3 rounded-md border px-4 py-3",
            warning.severity === "error"
              ? "border-[#FECACA] bg-[#FEF2F2] text-[#991B1B]"
              : "border-[#FDE68A] bg-[#FFFBEB] text-[#92400E]"
          )}
        >
          <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
          <div className="space-y-1">
            <p className={cn(portalDs.bodySm, "font-medium")}>{warning.message}</p>
            {warning.code === "untagged_sku_volume" && (
              <p className={portalDs.caption}>
                Flagged for review — untagged lines are excluded from the activation base.
              </p>
            )}
            {warning.code === "rate_pool_mismatch" && (
              <p className={portalDs.caption}>
                Active per-user rates must sum to 6% for the quarter pool.
              </p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ActivationCommissionWarningsBanner;
